module.exports = __webpack_public_path__ + "static/media/Sensors.0f5ed406.logo";